// extracted by mini-css-extract-plugin
module.exports = {"root":"c27DnoP","promoted":"O9lZ25"};